import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class SystemRebootNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Reboot';
        this.id = 'node_system_reboot';
        this.icon = 'AiOutlinePoweroff';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Reboot',
                portId: 'sys.reboot',
                params: [],
            },
        ];
        this.outputs = [];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `##### Reboot
This block reboots the device.`;
    }
}
